// WebRTC ICE 服务器配置（STUN/TURN）。
// 账号模式从中心 server 的 /api/ice-servers 动态获取（含 TURN 凭据）；
// 局域网/无 server 时回退到内置默认 STUN。

export interface IceServer {
  urls: string | string[];
  username?: string;
  credential?: string;
}

export const DEFAULT_ICE_SERVERS: IceServer[] = [
  { urls: 'stun:stun.l.google.com:19302' },
];
